import { consume, ContextType } from '@lit/context';
import { css, html, LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { contexts } from '../contexts.js';
import { PageOrganizationSettings } from '../page-organization-settings.js';
import { linkStyles } from './cssstyles.js';

@customElement('missing-billing-email-banner')
class MissingBillingEmailBanner extends LitElement {

  @consume({ context: contexts.org, subscribe: true }) private _org?: ContextType<typeof contexts.org>;

  render() {
    const org = this._org;
    if (!org)
      return nothing;
    if (!org.isMissingBillingEmail)
      return nothing;
    // Only people who can act see it; members can't change org settings.
    if (org.access !== 'admin' && org.access !== 'owner')
      return nothing;
    return html`
      <section>
        <sl-icon name=envelope></sl-icon>
        Organization <strong>${org.orgSlug}</strong> has no billing email — Stripe can't send invoices or receipts.
        <a href=${PageOrganizationSettings.url({ orgSlug: org.orgSlug })}>Add one</a>
      </section>
    `;
  }

  static styles = [linkStyles, css`
    section {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: var(--sl-spacing-2x-small);
      padding: var(--sl-spacing-2x-small);
      background-color: #ffc107;
    }

    a {
      text-decoration: underline;
    }
  `];
}
